module.exports = __webpack_public_path__ + "img/icon_tap_logo_a.36380254.png";